import { createApiSlice } from "@common";
import {
    CRUD_PERSONAL_MARITAL_STATUS
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addPersonalMaritalStatus",
        method: "post",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "message",
    },
    {
        name: "getPersonalMaritalStatus",
        method: "get",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "data",
    },
    {
        name: "updatePersonalMaritalStatus",
        method: "put",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "message",
    },
    {
        name: "deletePersonalMaritalStatus",
        method: "delete",
        url: CRUD_PERSONAL_MARITAL_STATUS,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "PersonalMaritalStatus",
    apiConfig,
    customReducers,
);
const PersonalMaritalStatusSlice = slice;
// Export the slice's reducer
export default PersonalMaritalStatusSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addPersonalMaritalStatus,
    getPersonalMaritalStatus,
    updatePersonalMaritalStatus,
    deletePersonalMaritalStatus
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
